export default "__VITE_ASSET__VzGgtZvk__"